import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Flex, Text } from '@spotify-internal/encore-web';
import { AuthScreen } from '@spotify/confidence-core-react';

import styles from './TransitionScreen.module.css';

export type TransitionScreenProps = {
  title: ReactNode;
  graphics?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  helperText?: ReactNode;
};

const Content = ({
  title,
  graphics = (
    <Link to="/" aria-label="Go to homepage">
      <AuthScreen.Logo />
    </Link>
  ),
  description,
  actions,
  helperText,
}: TransitionScreenProps) => (
  <AuthScreen.Main>
    <div className={styles.content}>
      {graphics && (
        <Flex
          className={styles.graphics}
          justifyContent="center"
          alignItems="center"
        >
          {graphics}
        </Flex>
      )}
      <AuthScreen.Title>{title}</AuthScreen.Title>
      {description && (
        <AuthScreen.Description className={styles.description}>
          {description}
        </AuthScreen.Description>
      )}
      {actions && (
        <AuthScreen.Actions
          className={styles.actions}
          alignItems="center"
          gap="tighter-2"
        >
          {actions}
        </AuthScreen.Actions>
      )}
      {helperText && (
        <Text
          variant="bodySmall"
          semanticColor="textSubdued"
          as="div"
          className={styles.helperText}
        >
          {helperText}
        </Text>
      )}
    </div>
  </AuthScreen.Main>
);

const TransitionScreenRoot = (props: TransitionScreenProps) => (
  <AuthScreen.Root>
    <Content {...props} />
  </AuthScreen.Root>
);

export const TransitionScreen = Object.assign(TransitionScreenRoot, {
  Content,
});
